exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-qty[data-v-3748f8cb] {\n  border-style: solid;\n  border-width: 0 0 1px 0;\n  width: 90px;\n}\n", ""]);

// exports
